import React, { PureComponent } from 'react'
import { debounce } from 'lodash'

const resizer = (WrappedComponent) => {
  class Resizer extends PureComponent {
    constructor(props) {
      super(props)
      this.state = {
        height: window.innerHeight,
        width: window.innerWidth
      }
      this.debounceResize = debounce(this.resize, 500)
    }

    resize = () => this.setState({ height: window.innerHeight, width: window.innerWidth })

    componentDidMount() {
      window.addEventListener('resize', this.debounceResize)
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.debounceResize)
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          rvh={this.state.height}
          rvw={this.state.width}
        />
      )
    }
  }
  Resizer.displayName = `Resizer(${WrappedComponent.displayName || WrappedComponent.name})`
  return Resizer
}

export default resizer
